import { render, staticRenderFns } from "./ProcessMenuItem.vue?vue&type=template&id=05559d48&"
import script from "./ProcessMenuItem.vue?vue&type=script&lang=js&"
export * from "./ProcessMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./ProcessMenuItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VListItemContent,VListItemTitle,VRow})
